import { Box, Stack } from "@mui/material";
import { AuthenticatedLayout } from "Components/Layout/AuthenticatedLayout";
import { SettlementPageContent } from "Components/Settlements/SettlementPageContent";
import { StyledPageWrapper } from "Components/Shared/StyledComponents";
import { Resources, useResource } from "Translations/Resources";

export const SettlementsPage = () => {
  const { t } = useResource();

  return (
    <AuthenticatedLayout
      title={t(Resources.Pages.Titles.Settlement)}
      backNavigation={{
        mode: "historyStack",
        fallbackUrl: null,
      }}
    >
      <StyledPageWrapper>
        <Box className="left-content">
          <Stack spacing={3}>
            <SettlementPageContent />
          </Stack>
        </Box>
      </StyledPageWrapper>
    </AuthenticatedLayout>
  );
};

export default SettlementsPage;
